import React from 'react'
import { type Control, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Typography } from '~/components/elements/Typography'
import { VStack } from '~/components/elements/VStack'

import { type FilterItem, type InputValues } from '../utils'

export type FilterGroupsDisplayProps<
  TFilterItem extends FilterItem<TCategory>,
  TCategory extends string,
> = {
  control: Control<InputValues<TFilterItem, TCategory>>
  filterToText: (filter: TFilterItem) => string
}

export const FilterGroupsDisplay = <
  TFilterItem extends FilterItem<TCategory>,
  TCategory extends string,
>({
  control,
  filterToText,
}: FilterGroupsDisplayProps<TFilterItem, TCategory>) => {
  const { t } = useTranslation()
  const filterGroups = useWatch({ control, name: 'filterGroups' })

  if (filterGroups.flat().length === 0) {
    return null
  }

  const filterGroupsText = filterGroups
    .map((filterGroup) => `【${filterGroup.map(filterToText).join(' AND ')}】`)
    .join(' OR ')

  return (
    <VStack backgroundColor="grayF3" padding={2} spacing={2}>
      <Typography fontWeight={700} variant="normal">
        {t('created_conditions')}
      </Typography>

      <Typography variant="normal">{filterGroupsText}</Typography>
    </VStack>
  )
}
